import { DvGridComponent, DvToolbarAction } from '@devinco/ui/grid';
import {
  ChangeDetectorRef,
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { DvTabBase } from '@devinco/ui/legacy';
import { AgGridModule } from 'ag-grid-angular';
import { GridOptions } from 'ag-grid-community';
import { GridOptionsService } from '@features/vt-grid/grid-options/grid-options.service';
import { VehiclePropertiesGridService } from './vehicle-properties-grid.service';
import { Entity } from '@shared/constants/entity';
import { DirectivesModule } from '@shared/directives/directives.module';
import { FilterModelWithKeys } from '@features/vt-grid/interfaces/grid-context';
import { EntityleFieldsValuesDto } from '@shared/interfaces/entity-fields-values';

@Component({
  selector: 'app-vehicle-properties-tab',
  imports: [DvGridComponent, AgGridModule, DirectivesModule],
  templateUrl: './vehicle-properties-tab.component.html',
  styleUrl: './vehicle-properties-tab.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [GridOptionsService, GridOptionsService, DirectivesModule],
})
export class VehiclePropertiesTabComponent extends DvTabBase implements OnInit {
  private gridOptionsService = inject(GridOptionsService);
  private gridService = inject(VehiclePropertiesGridService);
  private cdRef = inject(ChangeDetectorRef);

  actions: DvToolbarAction[];
  gridOptions: GridOptions<EntityleFieldsValuesDto> | undefined;

  ngOnInit(): void {
    this.actions = this.gridService.getGridActions();
  }

  onBaseActions(): void {}
  onEntityCreate(): void {}
  onEntityUpdate(): void {
    if (!this.entityId) return;

    if (!this.gridOptions) {
      this.setupGridOptions();
    } else {
      this.gridOptions.context.extraFilter = this.getFilterModel(this.entityId);
      this.gridOptions.context.loadClientSideData?.(
        this.gridOptions.context.extraFilter,
        true
      );
    }
  }

  private setupGridOptions(): void {
    this.gridOptions = this.gridOptionsService.clientSide(
      this.gridService.getColumnDefs(),
      Entity.VehicleFieldsValues,
      this.getFilterModel(this.entityId)
    );
    this.cdRef.detectChanges();
  }

  private getFilterModel(entityId: string): FilterModelWithKeys {
    return {
      EntityID: {
        filterType: 'number',
        type: 'equals',
        filter: entityId,
      },
    };
  }
}
